
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/instagram-tracking-example",
      function () {
        return require("private-next-pages/instagram-tracking-example.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/instagram-tracking-example"])
      });
    }
  